/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../../../scss/common/form/createEditFrom/CreateEditForm.scss'
import {
  RadioGroup,
  Radio,
  Panel,
  ButtonToolbar,
  Col,
  Input,
  SelectPicker
} from 'rsuite'
import {
  Button,
  FormikErrorMessage,
  Modal,
  Row,
  Section,
  TextInput,
  WhatsAppPreview,
  SMSTemplatePreview,
  AdvertisementTemplateView
} from 'shared'
import Uploader from 'shared/atoms/uploader/Uploader'
import { Formik, Form, FormikProps } from 'formik'
import Plus from '@rsuite/icons/Plus'
import { isFileObject, notifyError, notifySuccess, previewFile } from 'utils'
import CreateEditAudiences from 'pages/audience/createEditAudience/CreateEditAudiences'
import { Operator } from 'api/types'
import {
  LANGUAGE,
  templateValidationSchema,
  defaultTemplateFormValues,
  TemplateForm,
  TEMPLATE_FORM_FIELDS,
  TEMPLATE_TYPE,
  ADVERTISEMENT_TYPE,
  PLACEMENT_TYPE,
  LANGUAGES
} from '../utils'
import {
  useCreateTemplateMutation,
  useCreateAdvertisementMutation,
  useEditAdvertisementMutation,
  useCreateSmsTemplateMutation
} from '../templateApiSlice'

import { useGetChannelOnboardingsQuery } from '../../channelOnBoarding/channelOnboardingApiSlice'
import { WhatsAppTemplateFields, Advertisement, SmsTemplate } from '../types'

interface CreateTemplateProps {
  open: boolean;
  onClose: () => void;
  isEditMode?: boolean;
  advertisement?: Advertisement | null;
  defaultType?: any;
}

const CreateTemplate: React.FC<CreateTemplateProps> = ({
  open,
  onClose,
  isEditMode,
  advertisement,
  defaultType
}) => {
  const {
    TEMPLATE_TYPE: TEMPLATE_TYPE_FIELD,
    TEMPLATE_NAME,
    MESSAGE,
    NAME,
    MEDIA_FILE,
    HEADER_TEXT,
    IMAGE,
    VIDEO
  } = TEMPLATE_FORM_FIELDS
  const navigate = useNavigate()
  const [createTemplate] = useCreateTemplateMutation()
  const [createAdvertisement] = useCreateAdvertisementMutation()
  const [editAdvertisement] = useEditAdvertisementMutation()
  const [createSmsTemplate] = useCreateSmsTemplateMutation()
  const [isAudienceModalOpen, setIsAudienceModalOpen] = useState<boolean>(false)
  const [isSMS] = useState(true)
  const [isAdvertisement] = useState(true)
  const [smsTemplatePreviewData, setSmsTemplatePreviewData] =
    useState<any>(null)

  const [isSmsPreviewOpen, setIsSmsPreviewOpen] = useState(false)
  const [advertisementPreviewData, setAdvertisementPreviewData] =
    useState<any>(null)
  const [isAdvertisementPreviewOpen, setIsAdvertisementPreviewOpen] =
    useState(false)
  const [selectedTemplatePreviewData, setSelectedTemplatePreviewData] =
    useState<any>(null)
  const [isTemplatePreview, setIsTemplatePreview] = useState<boolean>(false)
  const [fileInfo, setFileInfo] = useState<string | undefined>(undefined)
  const [isEditAudienceMode, setIsEditAudienceMode] = useState<boolean>(true)
  const [videoPreview, setVideoPreview] = useState<string | undefined>(
    undefined
  )
  const [selectedChannelType, setSelectedChannelType] =
    useState<TEMPLATE_TYPE>(defaultType)
  const advertisementId = advertisement?.id ?? undefined

  const maxSize = 2 * 1024 * 1024
  const [hasMounted, setHasMounted] = useState(false)
  const MAX_VIDEO_SIZE_MB = 5 * 1024 * 1024
  const MAX_IMAGE_SIZE_MB = 2 * 1024 * 1024
  useEffect(() => {
    if (isEditMode && advertisement?.templateType) {
      setSelectedChannelType(advertisement.templateType as TEMPLATE_TYPE)
    }
  }, [isEditMode, advertisement])
  useEffect(() => {
    if (isEditMode && advertisement) {
      if (advertisement.image) {
        setFileInfo(advertisement.image)
      }
      if (advertisement.video) {
        setVideoPreview(advertisement.video)
      }
    }
  }, [isEditMode, advertisement])
  const initialValues: TemplateForm = useMemo(() => {
    return {
      ...defaultTemplateFormValues,
      [TEMPLATE_FORM_FIELDS.TEMPLATE_TYPE]: isEditMode
        ? TEMPLATE_TYPE.INAPP
        : defaultType,
      ...(isEditMode && advertisement
        ? {
            ...advertisement,
            channelOnboarding: advertisement.channelOnboarding
              ? { id: String(advertisement.channelOnboarding.id) }
              : undefined
          }
        : {})
    }
  }, [isEditMode, advertisement, defaultType])

  const { data: whatsAppChannel } = useGetChannelOnboardingsQuery({
    filters: [
      {
        fieldName: 'channel',
        operator: Operator.EQ,
        fieldValue: selectedChannelType
      }
    ]
  })
  const whatsAppChannelOptions =
    whatsAppChannel?.content
      ?.filter((item) => item.channel === 'WHATSAPP')
      .map((item) => ({
        label: item.businessInfo,
        value: item.channelId
      })) ?? []

  const smsChannels = whatsAppChannel?.content?.filter(
    (item) => item.channel === 'SMS'
  )
  const smsChannelOptions =
    smsChannels?.map((item) => ({
      label: item.businessInfo,
      value: item.id
    })) || []
  const appChannels = whatsAppChannel?.content?.filter(
    (item) => item.channel === 'INAPP'
  )
  const appchannelOptions =
    appChannels?.map((item) => ({
      label:
        typeof item.appName === 'string'
          ? item.appName
          : (item?.appName ?? JSON.stringify(item.appName)),
      value: item.id
    })) || []

  const languageOptions = Object.entries(LANGUAGE)?.map(([key, value]) => ({
    label: key.replace(/_/g, ' '),
    value
  }))

  const onSubmit = async (
    formValues: TemplateForm,
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
  ) => {
    let advertisementDTO: Advertisement | null = null
    let whatsAppTemplateDto: WhatsAppTemplateFields | null = null
    let smsTemplateDto: SmsTemplate | null = null

    if (formValues.templateType === TEMPLATE_TYPE.INAPP) {
      advertisementDTO = {
        active: formValues.active,
        message: formValues.message ?? '',
        redirect_url: formValues.redirect_url ?? '',
        placementType: formValues.placementType,
        type: formValues.type,
        languages: formValues.languages,
        duration: formValues.duration ?? 0,
        channelOnboarding: {
          id: formValues.channelOnboarding?.id ?? ''
        },
        name: formValues.name
      }
    } else if (formValues.templateType === TEMPLATE_TYPE.SMS) {
      smsTemplateDto = {
        name: formValues.name,
        message: formValues.message,
        channel: formValues.templateType,
        channelOnboarding: {
          id: formValues.channelId
        }
      }
    } else {
      whatsAppTemplateDto = {
        channelId: formValues.channelId,
        templateName: formValues.templateName,
        language: formValues.language as LANGUAGE,
        includeHeader: Boolean(
          ['media', 'text'].includes(formValues.headerType ?? '')
        ),
        headerType: formValues.headerType ?? undefined,
        headerText:
          formValues.headerType === 'media' ? '' : formValues.headerText,
        bodyText: formValues.bodyText ?? '',
        mediaFile:
          typeof formValues?.mediaFile === 'string'
            ? formValues.mediaFile
            : undefined
      }
    }

    const formData = new FormData()
    formData.append(
      'whatsAppTemplateDto',
      new Blob([JSON.stringify(whatsAppTemplateDto)], {
        type: 'application/json'
      })
    )
    const fileObject = formValues[MEDIA_FILE]
    let file: File | null = null

    if (isFileObject(fileObject)) {
      file = fileObject.blobFile
    } else if (fileObject instanceof File) {
      file = fileObject
    }
    const imagefileObject = formValues[TEMPLATE_FORM_FIELDS.IMAGE]
    let image: File | null = null

    if (imagefileObject) {
      if (isFileObject(imagefileObject)) {
        image = imagefileObject.blobFile
      } else if (imagefileObject instanceof File) {
        image = imagefileObject
      }
    }

    const videofileObject = formValues[TEMPLATE_FORM_FIELDS.VIDEO]
    let video: File | null = null

    if (videofileObject) {
      if (isFileObject(videofileObject)) {
        video = videofileObject.blobFile
      } else if (videofileObject instanceof File) {
        video = videofileObject
      }
    }
    try {
      if (smsTemplateDto) {
        await createSmsTemplate(smsTemplateDto).unwrap()
        notifySuccess('SMS Template created successfully')
      } else if (advertisementDTO) {
        if (isEditMode && advertisementId) {
          await editAdvertisement({
            advertisementDTO: {
              ...advertisementDTO,
              id: advertisementId
            },
            image,
            video
          }).unwrap()
          notifySuccess('Advertisement updated successfully!')
        } else {
          await createAdvertisement({ advertisementDTO, image, video }).unwrap()
          notifySuccess('Advertisement created successfully!')
        }
      } else if (whatsAppTemplateDto) {
        await createTemplate({
          whatsAppTemplateDto,
          file
        }).unwrap()
        notifySuccess('WhatsApp Template created successfully')
      }
      onClose()
      setFileInfo(undefined)
    } catch (error) {
      notifyError('Failed to save Template', { containerId: 'modalToast' })
    } finally {
      setSubmitting(false)
    }
  }
  const handleAudienceClose = () => {
    setIsAudienceModalOpen(false)
  }
  const renderFormButtons = (formikProps: FormikProps<TemplateForm>) => (
    <ButtonToolbar>
      {isEditMode ? (
        <>
          <Button
            className="formButton"
            id="reset"
            onClick={() => {
              formikProps.resetForm()
            }}
          >
            Reset to default
          </Button>
          <Button
            className="formButton"
            type="submit"
            appearance="primary"
            disabled={formikProps.isValidating || formikProps.isSubmitting}
          >
            Save changes
          </Button>
        </>
      ) : (
        <>
          <Button
            className="formButton"
            id="reset"
            onClick={() => {
              formikProps.resetForm()
              formikProps.setFieldValue('language', '')
              formikProps.setFieldValue('headerType', '')
              setFileInfo(undefined)
              setTimeout(() => {
                setIsTemplatePreview(false)
                setIsSmsPreviewOpen(false)
                setIsAdvertisementPreviewOpen(false)
                setSelectedTemplatePreviewData(undefined)
                setSmsTemplatePreviewData(undefined)
                setAdvertisementPreviewData(undefined)
                setVideoPreview(undefined)
              }, 0)
            }}
          >
            Reset
          </Button>
          <Button
            className="formButton"
            appearance="primary"
            type="submit"
            disabled={formikProps.isValidating ?? formikProps.isSubmitting}
          >
            Save
          </Button>
        </>
      )}
    </ButtonToolbar>
  )
  return (
    <>
      <Modal
        secondary
        open={open}
        onClose={onClose}
        title={advertisementId ? 'Edit Template' : 'Create Template'}
        size="calc(60% - 100px)"
        body={
          <>
            {selectedTemplatePreviewData && (
              <WhatsAppPreview
                className="campaign-preview"
                open={isTemplatePreview}
                selectedTemplate={selectedTemplatePreviewData}
                onClose={() => setIsTemplatePreview(false)}
              />
            )}
            {smsTemplatePreviewData && (
              <SMSTemplatePreview
                className="sms-preview"
                open={isSmsPreviewOpen}
                isSMS
                selectedTemplate={smsTemplatePreviewData}
                onClose={() => setIsSmsPreviewOpen(false)}
              />
            )}
            {isAdvertisementPreviewOpen && (
              <AdvertisementTemplateView
                className="sms-preview"
                isAdvertisement
                open={isAdvertisementPreviewOpen}
                selectedAdvertisementTemplate={advertisementPreviewData}
                onClose={() => setIsAdvertisementPreviewOpen(false)}
              />
            )}
            <Formik
              initialValues={initialValues}
              validationSchema={templateValidationSchema}
              onSubmit={onSubmit}
              validateOnChange
              validateOnBlur
            >
              {(formikProps: FormikProps<TemplateForm>) => {
                useEffect(() => {
                  if (
                    defaultType === TEMPLATE_TYPE.WHATSAPP &&
                    formikProps.values.templateType === TEMPLATE_TYPE.WHATSAPP
                  ) {
                    if (!hasMounted) {
                      setHasMounted(true)
                      return
                    }
                    setIsTemplatePreview(true)
                    setSelectedTemplatePreviewData({
                      components: [
                        ...(fileInfo
                          ? [
                              {
                                type: 'HEADER',
                                format: 'IMAGE',
                                example: {
                                  header_handle: [fileInfo]
                                }
                              }
                            ]
                          : formikProps.values.headerText
                            ? [
                                {
                                  type: 'HEADER',
                                  text: formikProps.values.headerText || ''
                                }
                              ]
                            : []),
                        {
                          type: 'BODY',
                          text: formikProps.values.bodyText || ''
                        }
                      ]
                    })
                  }
                }, [
                  formikProps.values.bodyText,
                  formikProps.values.headerText,
                  fileInfo
                ])
                useEffect(() => {
                  if (
                    formikProps.values.templateType === TEMPLATE_TYPE.SMS &&
                    formikProps.values.message
                  ) {
                    setIsSmsPreviewOpen(true)
                    setSmsTemplatePreviewData({
                      components: [
                        {
                          type: 'BODY',
                          text: formikProps.values.message || ''
                        }
                      ]
                    })
                  }
                }, [formikProps.values.message])

                useEffect(() => {
                  if (
                    formikProps.values.templateType === TEMPLATE_TYPE.INAPP &&
                    (formikProps.values.message || fileInfo || videoPreview)
                  ) {
                    setIsAdvertisementPreviewOpen(true)
                    setAdvertisementPreviewData({
                      message: formikProps.values.message || '',
                      image: fileInfo,
                      video: videoPreview
                    })
                  }
                }, [
                  formikProps.values.message,
                  fileInfo,
                  videoPreview,
                  formikProps.values.templateType
                ])

                return (
                  <Form className="create-edit">
                    <Panel>
                      <Row>
                        <Col xs={12}>
                          <RadioGroup
                            name={TEMPLATE_TYPE_FIELD}
                            inline
                            value={formikProps.values.templateType}
                            onChange={(value) => {
                              const selectedType = value as TEMPLATE_TYPE
                              formikProps.resetForm({
                                values: {
                                  ...initialValues,
                                  templateType: selectedType
                                }
                              })

                              setSelectedChannelType(value as TEMPLATE_TYPE)

                              setIsTemplatePreview(false)
                              setIsSmsPreviewOpen(false)
                              setIsAdvertisementPreviewOpen(false)

                              setFileInfo(undefined)
                              setVideoPreview(undefined)
                            }}
                            disabled={isEditMode}
                          >
                            <Radio value={TEMPLATE_TYPE.WHATSAPP}>
                              WhatsApp
                            </Radio>
                            <Radio value={TEMPLATE_TYPE.SMS}>SMS</Radio>
                            <Radio value={TEMPLATE_TYPE.INAPP}>APP</Radio>
                          </RadioGroup>
                        </Col>
                      </Row>
                      <FormikErrorMessage name={TEMPLATE_TYPE_FIELD} />

                      {formikProps.values.templateType ===
                        TEMPLATE_TYPE.WHATSAPP && (
                        <>
                          <Section title="Select Channel">
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={whatsAppChannelOptions}
                                  placeholder="Select channel"
                                  value={formikProps.values.channelId}
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      'channelId',
                                      value
                                    )
                                    formikProps.setFieldTouched(
                                      'channelId',
                                      true,
                                      false
                                    )
                                    formikProps.validateField('channelId')
                                  }}
                                  block
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => navigate('/channels')}
                                />
                                <FormikErrorMessage name="channelId" />{' '}
                              </Col>
                            </Row>
                          </Section>
                          <Section title="WhatsApp Template">
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name={TEMPLATE_NAME}
                                  placeholder="Enter template name"
                                />
                                <FormikErrorMessage name={TEMPLATE_NAME} />
                              </Col>
                              <Col xs={12}>
                                <SelectPicker
                                  data={languageOptions}
                                  placeholder="Select language"
                                  value={formikProps.values.language}
                                  onChange={(value) => {
                                    formikProps.setFieldValue('language', value)
                                    formikProps.setFieldTouched(
                                      'language',
                                      true,
                                      false
                                    )
                                    formikProps.validateField('language')
                                  }}
                                  block
                                />
                                <FormikErrorMessage name="language" />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={[
                                    { label: 'Text', value: 'text' },
                                    { label: 'Media', value: 'media' }
                                  ]}
                                  searchable={false}
                                  placeholder="Select header type"
                                  value={formikProps.values.headerType}
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      'headerType',
                                      value
                                    )
                                    if (value === 'text') {
                                      formikProps.setFieldValue(
                                        MEDIA_FILE,
                                        null
                                      )
                                      setFileInfo(undefined)
                                    } else if (value === 'media') {
                                      formikProps.setFieldValue(
                                        HEADER_TEXT,
                                        null
                                      )
                                    }

                                    setTimeout(() => {
                                      formikProps.setFieldTouched(
                                        'headerType',
                                        true
                                      )
                                      formikProps.validateField('headerType')
                                    }, 0)
                                  }}
                                  block
                                />
                                <FormikErrorMessage name="headerType" />
                              </Col>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name="bodyText"
                                  placeholder="Enter body text"
                                  as="textarea"
                                />
                                <FormikErrorMessage name="bodyText" />
                              </Col>
                            </Row>
                            {formikProps.values.headerType === 'text' && (
                              <Row>
                                <Col xs={12}>
                                  <TextInput
                                    formik={formikProps}
                                    name="headerText"
                                    placeholder="Enter Header Text"
                                  />
                                  <FormikErrorMessage name="headerText" />
                                </Col>
                              </Row>
                            )}
                          </Section>
                          {formikProps.values.headerType === 'media' && (
                            <Section title="Media">
                              <Row>
                                <Col xs={12}>
                                  <Uploader
                                    draggable
                                    accept=".jpeg,.jpg,.png,.gif,.svg"
                                    listType="picture"
                                    action="http://localhost:3000/post"
                                    fileInfo={fileInfo}
                                    onChange={(fileList) => {
                                      if (fileList.length > 0) {
                                        const file =
                                          fileList[fileList.length - 1]
                                        const validImageTypes = [
                                          'image/jpeg',
                                          'image/jpg',
                                          'image/png',
                                          'image/gif',
                                          'image/svg+xml',
                                          'image/webp'
                                        ]
                                        if (
                                          file.blobFile &&
                                          !validImageTypes.includes(
                                            file.blobFile.type
                                          )
                                        ) {
                                          notifyError(
                                            'Only image files are allowed ',
                                            {
                                              containerId: 'modalToast'
                                            }
                                          )
                                          fileList.pop()
                                          formikProps.setFieldValue(
                                            MEDIA_FILE,
                                            null
                                          )
                                        } else if (
                                          file.blobFile &&
                                          file.blobFile.size > maxSize
                                        ) {
                                          notifyError(
                                            'File size must be less than 2 MB',
                                            {
                                              containerId: 'modalToast'
                                            }
                                          )
                                          fileList.pop()
                                          formikProps.setFieldValue(
                                            MEDIA_FILE,
                                            null
                                          )
                                        } else {
                                          previewFile(
                                            file.blobFile,
                                            (value: any) => {
                                              setFileInfo(value)
                                            }
                                          )
                                          fileList.splice(
                                            0,
                                            fileList.length - 1
                                          )
                                          formikProps.setFieldValue(
                                            MEDIA_FILE,
                                            file
                                          )
                                        }
                                      } else {
                                        formikProps.setFieldValue(
                                          MEDIA_FILE,
                                          null
                                        )
                                      }
                                    }}
                                  />
                                  <FormikErrorMessage name={MEDIA_FILE} />
                                </Col>
                              </Row>
                            </Section>
                          )}
                        </>
                      )}
                      {formikProps.values.templateType ===
                        TEMPLATE_TYPE.SMS && (
                        <>
                          <Section title="Channel Details">
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={smsChannelOptions}
                                  placeholder="Select channel"
                                  value={formikProps.values.channelId}
                                  onChange={(value) => {
                                    formikProps.setFieldValue(
                                      'channelId',
                                      value
                                    )
                                    formikProps.setFieldTouched(
                                      'channelId',
                                      true,
                                      false
                                    )
                                    formikProps.validateField('channelId')
                                  }}
                                  block
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => navigate('/channels')}
                                />
                                <FormikErrorMessage name="channelId" />{' '}
                              </Col>
                            </Row>
                          </Section>

                          <Section title="Template Information">
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name={NAME}
                                  placeholder="Enter template name"
                                />
                                <FormikErrorMessage name={NAME} />
                              </Col>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name={MESSAGE}
                                  placeholder="Enter text here"
                                  as="textarea"
                                />
                                <FormikErrorMessage name={MESSAGE} />
                              </Col>
                            </Row>
                          </Section>
                        </>
                      )}
                      {formikProps.values.templateType ===
                        TEMPLATE_TYPE.INAPP && (
                        <>
                          <Section title="Select Channel">
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  data={appchannelOptions ?? []}
                                  placeholder="Select channel"
                                  value={
                                    formikProps.values[
                                      TEMPLATE_FORM_FIELDS.CHANNELONBOARDING
                                    ]?.id
                                  }
                                  onChange={(value) => {
                                    const selected = appchannelOptions.find(
                                      (option) => option.value === value
                                    )
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.CHANNELONBOARDING,
                                      {
                                        id: value,
                                        appName: selected?.label ?? ''
                                      }
                                    )
                                  }}
                                  disabled={isEditMode}
                                  block
                                />
                                <Plus
                                  className="dropdown-plus-button"
                                  onClick={() => navigate('/channels')}
                                />
                                <FormikErrorMessage name="channelOnboarding" />{' '}
                              </Col>
                            </Row>
                          </Section>
                          <Section title="Details">
                            <Row>
                              <Col xs={12}>
                                <Input
                                  name={TEMPLATE_FORM_FIELDS.NAME}
                                  value={formikProps.values.name}
                                  onChange={(value) =>
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.NAME,
                                      value
                                    )
                                  }
                                  placeholder="Enter Name "
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.NAME}
                                />
                              </Col>
                              <Col xs={12}>
                                <SelectPicker
                                  name={TEMPLATE_FORM_FIELDS.LANGUAGES}
                                  data={Object.values(LANGUAGES).map(
                                    (lang) => ({
                                      label: lang,
                                      value: lang
                                    })
                                  )}
                                  value={formikProps.values.languages}
                                  onChange={(value) =>
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.LANGUAGES,
                                      value
                                    )
                                  }
                                  placeholder="Select Language"
                                  disabled={isEditMode}
                                  block
                                  searchable={false}
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.LANGUAGES}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name={TEMPLATE_FORM_FIELDS.REDIRECT_URL}
                                  placeholder="Enter redirect URL"
                                  isDisabled={isEditMode}
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.REDIRECT_URL}
                                />
                              </Col>
                              <Col xs={12}>
                                <TextInput
                                  formik={formikProps}
                                  name={TEMPLATE_FORM_FIELDS.DURATION}
                                  placeholder="Enter duration (In Sec)"
                                  dataType="number"
                                  isDisabled={isEditMode}
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.DURATION}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <SelectPicker
                                  name={TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE}
                                  data={Object.values(ADVERTISEMENT_TYPE).map(
                                    (type) => ({
                                      label: type,
                                      value: type
                                    })
                                  )}
                                  value={formikProps.values.type}
                                  placeholder="Select Advertisement Type"
                                  onChange={(value) =>
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE,
                                      value
                                    )
                                  }
                                  disabled={isEditMode}
                                  block
                                  searchable={false}
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.ADVERTISEMENTTYPE}
                                />
                              </Col>
                              <Col xs={12}>
                                <SelectPicker
                                  name={TEMPLATE_FORM_FIELDS.PLACEMENTTYPE}
                                  data={Object.values(PLACEMENT_TYPE).map(
                                    (type) => ({
                                      label: String(type),
                                      value: type
                                    })
                                  )}
                                  value={formikProps.values.placementType}
                                  placeholder="Select Placement Type"
                                  onChange={(value) =>
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.PLACEMENTTYPE,
                                      value
                                    )
                                  }
                                  disabled={isEditMode}
                                  block
                                  searchable={false}
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.PLACEMENTTYPE}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12}>
                                <Input
                                  as="textarea"
                                  rows={5}
                                  name={TEMPLATE_FORM_FIELDS.MESSAGE}
                                  value={formikProps.values.message}
                                  onChange={(value) =>
                                    formikProps.setFieldValue(
                                      TEMPLATE_FORM_FIELDS.MESSAGE,
                                      value
                                    )
                                  }
                                  placeholder="Enter description here"
                                />
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.MESSAGE}
                                />
                              </Col>
                            </Row>
                          </Section>

                          <Section title="Media">
                            <Row>
                              <Col xs={12}>
                                <Uploader
                                  isVideo
                                  draggable
                                  accept=".mp4"
                                  listType="picture"
                                  action="http://localhost:3000/post"
                                  fileInfo={videoPreview}
                                  disabled={isEditMode}
                                  onChange={(fileList) => {
                                    if (fileList.length > 0) {
                                      const file = fileList[fileList.length - 1]
                                      if (
                                        file.blobFile &&
                                        file.blobFile.size > MAX_VIDEO_SIZE_MB
                                      ) {
                                        notifyError(
                                          'Video size must be less than  5 MB',
                                          { containerId: 'modalToast' }
                                        )
                                        fileList.pop()
                                        formikProps.setFieldValue(VIDEO, null)
                                      } else if (file.blobFile) {
                                        previewFile(
                                          file.blobFile,
                                          (value: any) => {
                                            setVideoPreview(value as string)
                                          }
                                        )
                                        fileList.splice(0, fileList.length - 1)
                                        formikProps.setFieldValue(
                                          VIDEO,
                                          file.blobFile
                                        )
                                      }
                                    } else {
                                      formikProps.setFieldValue(VIDEO, null)
                                    }
                                  }}
                                />
                              </Col>
                              <Col xs={12} className="video_label">
                                <Col xs={12}>
                                  <Uploader
                                    isVideo={false}
                                    draggable
                                    accept=".jpeg,.jpg,.png,.gif,.svg,.webep"
                                    listType="picture"
                                    action="http://localhost:3000/post"
                                    fileInfo={fileInfo}
                                    disabled={isEditMode}
                                    onChange={(fileList) => {
                                      if (fileList.length > 0) {
                                        const file =
                                          fileList[fileList.length - 1]
                                        if (
                                          file.blobFile &&
                                          file.blobFile.size > MAX_IMAGE_SIZE_MB
                                        ) {
                                          notifyError(
                                            'File size must be less than 2 mb',
                                            { containerId: 'modalToast' }
                                          )
                                          fileList.pop()
                                          formikProps.setFieldValue(IMAGE, null)
                                        } else {
                                          previewFile(
                                            file.blobFile,
                                            (value: any) => {
                                              setFileInfo(value)
                                            }
                                          )
                                          fileList.splice(
                                            0,
                                            fileList.length - 1
                                          )
                                          formikProps.setFieldValue(IMAGE, file)
                                        }
                                      } else {
                                        formikProps.setFieldValue(IMAGE, null)
                                      }
                                    }}
                                  />
                                  <FormikErrorMessage name={IMAGE} />
                                </Col>
                                <FormikErrorMessage
                                  name={TEMPLATE_FORM_FIELDS.IMAGE}
                                />
                              </Col>
                            </Row>
                          </Section>
                        </>
                      )}
                    </Panel>
                    <Panel className="panel-buttons">
                      {renderFormButtons(formikProps)}
                    </Panel>
                  </Form>
                )
              }}
            </Formik>
          </>
        }
      />
      {isAudienceModalOpen && (
        <CreateEditAudiences
          open={isAudienceModalOpen}
          setOpen={handleAudienceClose}
          isEditMode={isEditAudienceMode}
          setIsEditMode={setIsEditAudienceMode}
          audienceData={null}
        />
      )}
    </>
  )
}

export default CreateTemplate
